import ContratoInterceptor from '@finx/web-repository/src/apis/Contrato/ContratoInterceptor'
import FactoryResponse from '@/factories/FactoryResponse'

const factory = new FactoryResponse()
const api = new ContratoInterceptor()

export default {
  async getAllContratos(prestadorId: string) {
    const request = await api.get(`contratos-hospitais?prestadorId=${prestadorId}`)
    return factory.build(request)
  },

  async getAllPrestadores() {
    const request = await api.get('contratos-hospitais/prestadores')
    return factory.build(request)
  },

  async getContratoById(contratoId: string) {
    const request = await api.get(`contratos-hospitais/${contratoId}`)
    return factory.build(request)
  },

  async getAllGestores() {
    const request = await api.get('gestores')
    return factory.build(request)
  },

  async getAllProfissionais() {
    const request = await api.get('profissionais-executantes')
    return factory.build(request)
  },

  async getAllRegrasDisponiveis(contratoId: string) {
    const request = await api.get(`contratos-hospitais/${contratoId}/regras-disponiveis`)
    return factory.build(request)
  },

  async postGestoresByContratoId(contratoId: string, payload: string[]) {
    const request = await api.post(`contratos-hospitais/${contratoId}/gestores`, payload)
    return factory.build(request)
  },

  async postProfissionaisByContratoId(contratoId: string, payload: string[]) {
    const request = await api.post(`contratos-hospitais/${contratoId}/profissionais-executantes`, payload)
    return factory.build(request)
  },

  async postRegrasByContratoId(contratoId: string, payload: string[]) {
    const request = await api.post(`contratos-hospitais/${contratoId}/regras`, payload)
    return factory.build(request)
  },

  async deleteRegrasByContratoId(contratoId: string, regraId: string) {
    const request = await api.delete(`contratos-hospitais/${contratoId}/regras/${regraId}`)
    return factory.build(request)
  },

  async deleteGestoresByContratoId(contratoId: string, payload: string[]) {
    const request = await api.post(`contratos-hospitais/${contratoId}/gestores/delete`, payload)
    return factory.build(request)
  },

  async deleteProfissionaisByContratoId(contratoId: string, payload: string[]) {
    const request = await api.post(`contratos-hospitais/${contratoId}/profissionais-executantes/delete`, payload)
    return factory.build(request)
  },

  async removeContratoGestor(params: any) {
    const request = await api.delete(`contratos/${params.contratoId}/gestores/${params.gestorId}`)
    return factory.build(request)
  },

  async addGestor(contratoId: string, params: any) {
    const request = await api.post(`contratos/${contratoId}/gestores?ehCadastradoPorGestor=true`, params)
    return factory.build(request)
  },

  async addNovoContrato(params: any) {
    const request = await api.post('contratos', params)
    return factory.build(request)
  },
}
